var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import { classNames } from '@shapeable/utils';
var cls = classNames('markdown-content-link');
import { useLink } from '../hooks/use-link';
import { CitationReference } from '../entities/citation-reference';
import { first, isString } from 'lodash';
import { ReferenceNumberLink } from './reference-number-link';
import { EntityContentEmbed } from './entity-content-embed';
import { useLinkEmbeds } from '../context/link-embed-components-context';
export var CITATION_PATTERN = "\\/citation\\/([^\\/\\)]*)\\/?";
// check if the child (link text) is a simple number
function childrenAreNumericLink(variable) {
  return Array.isArray(variable) && variable.length === 1 && typeof variable[0] === "string" && /^-?\d+$/.test(variable[0]);
}
export var MarkdownContentLink = function (props) {
  var _a = props.href,
    href = _a === void 0 ? '' : _a,
    children = props.children,
    rest = __rest(props, ["href", "children"]);
  var _b = useLinkEmbeds(),
    linkEmbeds = _b.linkEmbeds,
    linkRichEmbeds = _b.linkRichEmbeds;
  var richEmbedByUrl = React.useMemo(function () {
    return new Map(linkRichEmbeds.map(function (e) {
      return [e.url, e];
    }));
  }, [linkRichEmbeds]);
  var linkEmbedByUrl = React.useMemo(function () {
    return new Map(linkEmbeds.map(function (e) {
      return [e.url, e];
    }));
  }, [linkEmbeds]);
  var matches = isString(href) && href.match(new RegExp(CITATION_PATTERN, "i")) || [];
  var Link = useLink().Link;
  var firstChild = first(props.children);
  var isEmbeddableLink = firstChild === props.href;
  var linkRichEmbed = richEmbedByUrl.get(href);
  if (matches && matches.length > 1) {
    return React.createElement(CitationReference, {
      id: matches[1]
    }, children);
  }
  if (isEmbeddableLink) {
    // this is an external link 
    var linkEmbed = linkEmbedByUrl.get(href);
    // if (href.match(/\.(jpg|jpeg|png|gif|webm)/i)) {
    //   return <div>test</div>;
    // }
    if (linkEmbed) {
      return React.createElement(EntityContentEmbed, {
        key: href,
        entity: linkEmbed
      });
    }
    ;
  }
  if (linkRichEmbed && isString(firstChild) && firstChild.startsWith('LinkTitle:')) {
    return React.createElement(EntityContentEmbed, {
      key: linkRichEmbed.id,
      entity: linkRichEmbed
    });
  }
  if (childrenAreNumericLink(children)) {
    return React.createElement(ReferenceNumberLink, {
      title: href,
      href: href
    }, children);
  }
  return React.createElement(Link, __assign({
    href: href
  }, rest), children);
};
export var MarkdownContentLinkTargetBlank = function (props) {
  return React.createElement(MarkdownContentLink, __assign({}, props, {
    target: "_blank"
  }), props.children);
};